import { state } from '../state'
import type { PushOptInEvent } from '../types'

const EVENT_NAME = 'opt_in.push'
const TOKEN_PROVIDER: PushOptInEvent['token_provider'] = 'fcm'
const DEFAULT_PLATFORM: PushOptInEvent['token_platform'] = 'web'

export async function trackOptInPush(params: { token: string, topics?: string }): Promise<void> {
  const token = params?.token?.trim()
  const topics = params?.topics?.trim()

  if (!token) {
    console.warn('[montilla] trackOptInPush requires a non-empty token value')
    return
  }

  const payload = {
    token_value: token,
    token_provider: TOKEN_PROVIDER,
    token_platform: DEFAULT_PLATFORM,
    topics: topics ?? '',
  } satisfies PushOptInEvent

  await state.eventBus.dispatch({
    name: EVENT_NAME,
    domain: state.source,
    attributes: payload,
    timestamp: new Date().toISOString(),
  })
}
